import React, { useState, useEffect } from "react";
import DataValidation, { DATA_VALIDATION_TYPES } from "../../../RestaurantWidget/utilities/helper/dataValidation";
import { useHistory } from 'react-router'
import { Checkbox, Col, InputBox, Label, Row, Space, Typography } from 'witmeg-ui-system'
import { LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../RestaurantWidget/utilities/helper/helper";
import { useSelector } from "react-redux";
import cartIc from "../../assets/cart-gray.svg"
import arrow from "../../assets/images/down-arrow.svg"
import Footer from "../../components/Footer/Footer";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'

const VoucherDefaultOrderConfirmationPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);

    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const userDetails = localStorage.getItem('fullUserDetails')
    let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    const address = userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Billing") : null
    const customerDetailsInitialState = {
        firstName: {
            value: userDetails ? parsedUserDetails.FirstName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        lastName: {
            value: userDetails ? parsedUserDetails.LastName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        mobileNo: {
            value: address ? address.Phone : '',
            hasError: false,
            errorType: null,
            errorMessage: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_PHONE_NO],
        },
        emailAddress: {
            value: userDetails ? parsedUserDetails.Email : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_EMAIL],
        },
        customerAddress: {
            line1: {
                value: address ? address.AddressLine1 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            line2: {
                value: address ? address.AddressLine2 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: address ? address.StateProvinceRegion : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            city: {
                value: address ? address.City : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            postcode: {
                value: address ? address.PostZipCode : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
        },
        deliveryAddress: {
            line1: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            line2: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            city: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            postcode: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                // validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                validations: [],
            },
        },
        isDeliveryAddressSame: true,
    };
    let history = useHistory();
    const [orderType, setOrderType] = useState(restaurantDataState.orderDetails.FulfillmentType)
    const [customerDetails, setCustomerDetails] = useState(customerDetailsInitialState);
    const [isCollapsed, setIsCollapsed] = useState("closed")
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (orderType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup) => {
        return (
            <div>
                <span>{selectedGroup.Title} <span className="qty-box">{selectedGroup.Quantity.Amount}</span></span>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title} ({getPrice(selectedItem.PriceInfo.BaseTotalPrice)})
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };
    const onFormDataChanged = (property, value) => {
        setCustomerDetails((prevState) => {
            const [key, subKey] = property.split('.');

            if (subKey) {
                return {
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        [subKey]: {
                            ...prevState[key][subKey],
                            value,
                            errorMessage: "",
                            hasError: false
                        },
                    },
                };
            }

            return {
                ...prevState,
                [property]: {
                    ...prevState[property],
                    value,
                    errorMessage: "",
                    hasError: false
                },
            };
        });
    };
    const toggleIsDeliveryAddressDifferent = () => {
        setCustomerDetails(prevState => ({
            ...prevState,
            isDeliveryAddressSame: !prevState.isDeliveryAddressSame,
        }));
    };
    const getErrorMessage = (type) => {
        let message = ""
        switch (type) {
            case 'REQUIRED_FIELD':
                message = "This field is required."
                break;
            case 'IS_EMAIL':
                message = "Please enter a valid email address."
                break;
            case 'IS_TEXT_ONLY':
                message = "Input must contain letters only"
                break;
            case 'IS_POSTCODE':
                message = "Please enter a valid Postcode."
                break;
            case 'IS_PHONE_NO':
                message = "Please enter a valid Phonenumber."
                break;
            default:
                break;
        }
        return message
    }
    const validateFieldSet = (fields) => {
        let pageHasError = false;
        const newFields = { ...fields };

        for (const key in fields) {
            if (!fields.hasOwnProperty(key)) continue;

            let validationRes = { hasError: false, errorType: null };

            for (const validation of fields[key].validations) {
                if (validationRes.hasError) break;

                validationRes = DataValidation(validation, fields[key].value, fields[key].additional ?? null);
                fields[key].errorMessage = getErrorMessage(validationRes.errorType)
            }

            if (validationRes.hasError) pageHasError = true;

            newFields[key] = {
                ...newFields[key],
                ...validationRes,
            };
        }

        return {
            fields: newFields,
            hasError: pageHasError,
        };
    };

    const validateAllFormData = () => {
        return new Promise((resolve) => {
            let pageError = false;

            setCustomerDetails(prevState => {
                const { customerAddress, deliveryAddress, isDeliveryAddressSame, ...basicFields } = prevState;
                const newBasic = validateFieldSet(basicFields);
                const newCustomerAddress = validateFieldSet(customerAddress);
                const newDeliveryAddress = isDeliveryAddressSame
                    ? { fields: customerAddress, hasError: false }
                    : validateFieldSet(deliveryAddress);

                const pageHasError = newBasic.hasError || newCustomerAddress.hasError || newDeliveryAddress.hasError;
                pageError = pageHasError;

                if (!pageHasError) {
                    const customerFormData = {
                        ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        Name: {
                            DisplayName: basicFields.firstName.value,
                            FirstName: basicFields.firstName.value,
                            LastName: basicFields.lastName.value,
                        },
                        Email: basicFields.emailAddress.value,
                        Contact: {
                            Number: basicFields.mobileNo.value,
                            PinCode: "+44",
                            CountryISO2: "GB"
                        },
                        BillingAddress: {
                            Id: "",
                            AddressType: "",
                            AddressLine1: customerAddress.line1.value,
                            AddressLine2: customerAddress.line2?.value || '',
                            StateProvinceRegion: customerAddress.state.value,
                            PostZipCode: customerAddress.postcode.value,
                            Country: customerAddress.country.value,
                            CountryCode: "",
                            AddressLabel: "",
                            Longitude: 0,
                            Latitude: 0,
                            Additional: {
                                Instruction: "",
                                InteractionType: ""
                            }
                        },
                        DeliveryAddress: {
                            Id: "",
                            AddressType: "",
                            AddressLine1: isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                            AddressLine2: isDeliveryAddressSame ? customerAddress.line2.value || '' : deliveryAddress.line2?.value || '',
                            StateProvinceRegion: isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                            PostZipCode: isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                            Country: isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                            CountryCode: "",
                            AddressLabel: "",
                            Longitude: 0,
                            Latitude: 0,
                            Additional: {
                                Instruction: "",
                                InteractionType: ""
                            }
                        },
                    };
                    let data = {
                        "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        "CompanyName": "",
                        "UserName": basicFields.firstName.value.toLowerCase(),
                        "FirstName": basicFields.firstName.value,
                        "LastName": basicFields.lastName.value,
                        "Addresses": [
                            {
                                "AddressType": "Billing",
                                "HouseNo": "",
                                "AddressLine1": customerAddress.line1.value,
                                "AddressLine2": customerAddress.line2?.value || "",
                                "City": customerAddress.city.value,
                                "StateProvinceRegion": customerAddress.state.value,
                                "PostZipCode": customerAddress.postcode.value,
                                "Country": customerAddress.country.value,
                                "Phone": getNationalNumber(basicFields.mobileNo.value),
                                "Fax": "",
                                "Email": basicFields.emailAddress.value,
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            },
                            {
                                "AddressType": "Delivery",
                                "HouseNo": "",
                                "AddressLine1": isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                                "AddressLine2": isDeliveryAddressSame ? (customerAddress.line2?.value || "") : (deliveryAddress.line2?.value || ""),
                                "City": customerAddress.city.value,
                                "StateProvinceRegion": isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                                "PostZipCode": isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                                "Country": isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                                "Phone": getNationalNumber(basicFields.mobileNo.value),
                                "Fax": "",
                                "Email": basicFields.emailAddress.value,
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            }
                        ],
                        "Email": basicFields.emailAddress.value,
                    }
                    localStorage.setItem("fullUserDetails", JSON.stringify(data))


                    setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                }
                return {
                    ...prevState,
                    ...newBasic.fields,
                    customerAddress: newCustomerAddress.fields,
                    deliveryAddress: newDeliveryAddress.fields,
                };
            });

            setTimeout(() => resolve(pageError), 0);
        });
    };

    const getNationalNumber = (phone) => {
        if (!phone) return '';
        try {
            const parsed = parsePhoneNumberWithError(phone);
            return parsed ? parsed.nationalNumber : phone;
        } catch (error) {
            return phone;
        }
    };

    return (
        <div className="Order-confirmation">
            <div className="Order-confirmation-header">
                <div className="header-text-cont">Order Confirmation</div>
            </div>
            <div className="Order-confirmation-inner">
                <div className="eco-mb-16 Order-confirmation-inner-left">

                    <div className="order-form-summary ">
                        <div className="form-header">Contact Details</div>
                        <div className="order-form-container order-det">
                            <div className="personal-header">Personal Details</div>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>First Name</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                onChange={(e) => onFormDataChanged('firstName', e.target.value)}
                                                type="text"
                                                value={customerDetails.firstName.value}
                                                error={customerDetails.firstName.hasError}
                                            />
                                            <div className="error-text">{customerDetails.firstName.errorMessage}</div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Last Name</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('lastName', e.target.value)} type="text" value={customerDetails.lastName.value} error={customerDetails.lastName.hasError} />
                                            <div className="error-text">{customerDetails.lastName.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Email Address</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('emailAddress', e.target.value)} type="text" value={customerDetails.emailAddress.value} error={customerDetails.emailAddress.hasError} />
                                            <div className="error-text">{customerDetails.emailAddress.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Mobile Number</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <PhoneInput
                                                defaultCountry="GB"
                                                placeholder="Enter phone number"
                                                value={customerDetails.mobileNo.value}
                                                onChange={
                                                    (e) => onFormDataChanged('mobileNo', e)
                                                }

                                            />
                                            <div className="error-text">{customerDetails.mobileNo.errorMessage}</div>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                            <div className="personal-header">Billing Address</div>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Address Line 1</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('customerAddress.line1', e.target.value)} type="text" value={customerDetails.customerAddress.line1.value} error={customerDetails.customerAddress.line1.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.line1.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24">
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label>Address Line 2</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('customerAddress.line2', e.target.value)} type="text" value={customerDetails.customerAddress.line2.value} error={customerDetails.customerAddress.line2.hasError} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Postcode</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('customerAddress.postcode', e.target.value)} type="text" value={customerDetails.customerAddress.postcode.value} error={customerDetails.customerAddress.postcode.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.postcode.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>City</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('customerAddress.city', e.target.value)} type="text" value={customerDetails.customerAddress.city.value} error={customerDetails.customerAddress.city.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.city.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>State</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('customerAddress.state', e.target.value)} type="text" value={customerDetails.customerAddress.state.value} error={customerDetails.customerAddress.state.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.state.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label>Country</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox type="text" value={customerDetails.customerAddress.country.value} disabled />
                                            {/* <Select noBorder onChange={(value) => onFormDataChanged('customerAddress.country', value)} options={pageState.countryData} value={customerDetails.customerAddress.country.value} hasError={customerDetails.customerAddress.country.hasError} placeholder="" /> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>




                        </div>
                    </div>
                </div>
                <div className="Order-confirmation-inner-right ">
                    {isCartDataAvailable ?
                        <div className="order-form-summary " style={{ marginTop: "72px" }}>
                            <div className="order-form-container">
                                <div className="form-header-text">Order Summary</div>
                                {isCartDataAvailable &&
                                    <>
                                        <div className="header-conater"><div className="header-conater-left">
                                            <img alt="" src={cartIc} />
                                            <div className="form-header-text-cont">Cart Items</div>
                                            <div className="text-sub ">({restaurantDataState.orderCartData.Items.length} {restaurantDataState.orderCartData.Items.length === 1 ? "item" : "items"})</div></div>
                                            <div className="header-conater-right"><img alt="" src={arrow} className={`arrow-${isCollapsed}`} onClick={() => {
                                                if (isCollapsed === "open") {
                                                    setIsCollapsed("closed")
                                                } else {
                                                    setIsCollapsed("open")
                                                }
                                            }} /></div></div>
                                        {isCollapsed === "open" && <div className="order-cart-list">
                                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                const _hasAddons = item.SelectedModifierGroups.length > 0;
                                                return (
                                                    <div className="order-cart-item" key={index}>
                                                        <div className="order-cart-item-left">
                                                            <div className="cart-item-image-cont">

                                                                <Typography
                                                                    style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                    className="cart-item-image">
                                                                </Typography>
                                                            </div>
                                                            <div className='item-details-container-left'>
                                                                <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                                <div className="modifiers-text">
                                                                    {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                        <span key={index}> {renderModifierGroups(selectedGroup)} </span>
                                                                    ))}
                                                                </div>
                                                                <div className='item-cart-price'>   {getPrice(item.PriceInfo.TotalPrice)}</div>
                                                            </div>
                                                        </div>
                                                        <div className="order-cart-item-right">
                                                            <div className="qty-container">
                                                                {item.Quantity.Amount}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>}

                                    </>}
                                <div className="price-list">
                                    <div className="form-header-text">Order Total</div>
                                    <div className="price-list-inner">
                                        <div className="price-list-inner-left">Sub total</div>
                                        <div className="price-list-inner-right">     {restaurantDataState.orderDetails.Payment.
                                            PaymentDetail.OrderTotal.Net.Formatted}</div>

                                    </div>
                                    {restaurantDataState?.orderDetails?.Payment.
                                        PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                            return (
                                                <div className="price-list-inner" key={key}>
                                                    <div className="price-list-inner-left">{fee.Description}</div>
                                                    <div className="price-list-inner-right">
                                                        {fee.Amount.DisplayAmount}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                                <div className="price-list">
                                    <div className="price-list-inner-total" >
                                        <div className="total-value-text ">Total Price</div>
                                        <div className="total-value-text ">
                                            {restaurantDataState.orderDetails.Payment.
                                                PaymentDetail.OrderTotal.Gross.Formatted}
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-btn-order" onClick={() => {
                                    validateAllFormData().then((error) => {
                                        if (!error) {
                                            history.push('/order/summary');
                                        }
                                    })

                                }}>Continue to Payment</div>
                            </div>
                        </div> : ""}
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default VoucherDefaultOrderConfirmationPage